module.exports = __webpack_public_path__ + "static/media/Bulgaria.ea7176b9.png";